export default __webpack_public_path__ + "static/media/arrow_active.09acf155.svg";